import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { UserTypeListModel } from '../../models/user-types/user-types';

@Injectable({
  providedIn: 'root'
})
export class UserTypesService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
  ) { }

  public getList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<UserTypeListModel>(`${this.environmentService.getApiURL()}/usertypes`, options);
  }
}
